/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var userHasRole = require('common/util/userHasRole');

var NonDepInternalIndividualView = require('./NonDepInternalIndividualView');

var tmplNonDepIndividualGeneralInformationSectionView = require('../templates/NonDepIndividualGeneralInformationSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepIndividualGeneralInformationSectionView,

  className: 'non-dep-individual-general-information-section-view',

  ui: {
    nonDepIndividual: '.individual-form',
    editIndividualButton: '.edit-individual'
  },

  regions: {
    nonDepIndividual: '@ui.nonDepIndividual'
  },

  templateHelpers: function() {
    return { individualType: this.options.individualType };
  },

  onBeforeShow: function() {
    this.showChildView(
      'nonDepIndividual',
      new NonDepInternalIndividualView({
        model: this.model,
        isReadOnly: this.options.isReadOnly,
        individualType: this.options.individualType
      })
    );

    //TO DO: Confirm which roles have access to this button
    if (userHasRole('ND - Manager')) {
      this.ui.editIndividualButton.removeClass('collapse');
    }
  }
});
